import { useIntl } from 'react-intl';
import type { FieldErrors, FieldValues, Path, UseFormRegister } from 'react-hook-form';
import FieldLabel from '@/shared/components/FieldLabel';
import FieldError from '@/shared/components/FieldError';
import { OriginCountrySelect } from '@catalog';
import { inputClass } from '@/shared/utils/styles';
import { hasFieldError, type ServerErrors } from '@/shared/utils/fieldErrors';

interface Props<T extends FieldValues> {
  register: UseFormRegister<T>;
  errors: FieldErrors;
  serverErrors: ServerErrors;
  answeredByDomain: boolean;
  defaultCountry: string;
}

export default function CountryField<T extends { country: string }>({
  register,
  errors,
  serverErrors,
  answeredByDomain,
  defaultCountry,
}: Props<T>) {
  const intl = useIntl();
  const field = register('country' as Path<T>, { required: true });

  if (answeredByDomain) return <input type="hidden" {...field} />;

  return (
    <div>
      <FieldLabel htmlFor="country" labelId="auth.signUp.countryLabel" />
      <OriginCountrySelect
        id="country"
        className={inputClass(hasFieldError('country', errors, serverErrors))}
        placeholder={intl.formatMessage({ id: 'auth.signUp.countryPlaceholder' })}
        loadingText={intl.formatMessage({ id: 'auth.signUp.countryLoading' })}
        preferredValue={defaultCountry}
        {...field}
      />
      <FieldError field="country" errors={errors} serverErrors={serverErrors}
        messages={{ required: 'auth.signUp.countryRequired' }} />
    </div>
  );
}
